<template>
  <section class="personal-stats">
    <h2 class="section-title">个人业绩</h2>
    <div class="divider" />
    <ul class="stats-grid">
      <li v-for="(cell, index) in items" :key="index" class="cell">
        <p class="cell-value">{{ cell.value }}</p>
        <p class="cell-label">{{ cell.label }}</p>
      </li>
    </ul>
  </section>
</template>

<script>
export default {
  name: "PersonalStatsSection",
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.personal-stats {
  margin-bottom: 40px;
}

.section-title {
  margin: 0 0 12px;
  font-size: 32px;
  font-weight: 600;
  color: #1a1a1a;
}

.divider {
  height: 1px;
  background: linear-gradient(
    90deg,
    #e5c486 0%,
    rgba(229, 196, 134, 0.2) 100%
  );
  margin-bottom: 28px;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px 12px;
  list-style: none;
  margin: 0;
  padding: 0;
}

.cell {
  text-align: center;
  min-width: 0;
}

.cell-value {
  margin: 0 0 8px;
  font-size: 24px;
  font-weight: 600;
  color: #1a1a1a;
  line-height: 1.25;
  word-break: break-word;
}

.cell-label {
  margin: 0;
  font-size: 20px;
  color: #8c8c8c;
  line-height: 1.2;
}
</style>
